import ApiService from "../../util/ApiService";
import {
  GET_DI_VIEWMODEL_REQUEST,
  GET_DI_VIEWMODEL_SUCCESS,
  GET_DI_VIEWMODEL_ERROR,
  ADD_INPUT,
  UPDATE_INPUT,
  RESET_FORM,
  GET_SUGGESTIONS_SUCCESS,
  GET_SUGGESTIONS_ERROR,
  CLEAR_SUGGESTIONS,
  REMOVE_INPUT,
  GET_DI_DETAILS_VIEWMODEL_SUCCESS,
  GET_DI_DETAILS_VIEWMODEL_ERROR,
  SET_INTERACTING_DETAILS,
  CLEAR_INTERACTING_DETAILS,
  GET_DI_RESULTS_REQUEST,
  GET_DI_RESULTS_SUCCESS,
  GET_DI_RESULTS_ERROR,
  SET_SELECTED_INTERACTION_TYPE,
  CACHE_PREVIOUS_DRUGS_CODES,
} from "../actionTypes";

const genericErrorViewModel = {
  name: "We're sorry! This page is temporarily unavailable.",
  message: "We are working on resolving the problem. Please try again shortly.",
};

//backLink details on client side when edge is down
const genericMonographErrorViewModel = {
  back: {
    type: "spa",
    icon: {
      color: "secondary",
      glyph: "navigate_before",
      size: "md",
    },
    name: "Back To Checker",
    function: "backToChecker",
  },
  errorObject: genericErrorViewModel,
};

export const fetchDrugInteractionsViewModel = async (dispatch) => {
  dispatch({ type: GET_DI_VIEWMODEL_REQUEST });

  try {
    const { data } = await ApiService.getDrugInteractionsViewModel();

    if (data.viewModel.error) {
      dispatch({
        type: GET_DI_VIEWMODEL_ERROR,
        payload: data.viewModel.error,
      });
    } else {
      dispatch({
        type: GET_DI_VIEWMODEL_SUCCESS,
        payload: data.viewModel,
      });
    }
  } catch (err) {
    dispatch({ type: GET_DI_VIEWMODEL_ERROR, payload: genericErrorViewModel });
  }
};

export const acceptPolicy = async (dispatch, acceptUrl) => {
  dispatch({ type: GET_DI_VIEWMODEL_REQUEST });

  try {
    const { data } = await ApiService.acceptPolicy(acceptUrl);

    dispatch({
      type: GET_DI_VIEWMODEL_SUCCESS,
      payload: data.viewModel,
    });
  } catch (err) {
    dispatch({ type: GET_DI_VIEWMODEL_ERROR, payload: genericErrorViewModel });
  }
};

export const addInput = (dispatch) => dispatch({ type: ADD_INPUT });
export const removeInput = (dispatch, id) =>
  dispatch({ type: REMOVE_INPUT, payload: { id } });
export const updateInput = (dispatch, payload) =>
  dispatch({ type: UPDATE_INPUT, payload });

export const resetForm = (dispatch) => dispatch({ type: RESET_FORM });

export const clearSuggestions = (dispatch) =>
  dispatch({ type: CLEAR_SUGGESTIONS });

export const getSuggestions = async (dispatch, url, value) => {
  try {
    const truncValue = value.substring(0, 198);
    const { data } = await ApiService.getDrugNameSuggestions(url, truncValue);

    dispatch({
      type: GET_SUGGESTIONS_SUCCESS,
      payload: { suggestions: data, searchCondition: truncValue },
    });
  } catch (e) {
    dispatch({ type: GET_SUGGESTIONS_ERROR });
  }
};

export const fetchDrugInteractionResults = async (dispatch, apiPath, drugs) => {
  dispatch({ type: GET_DI_RESULTS_REQUEST });

  try {
    const { data } = await ApiService.getDrugInteractionResults(apiPath, drugs);
    const { content, error } = data.viewModel;
    const errorData = error || genericErrorViewModel;
    if (content) {
      dispatch({
        type: CACHE_PREVIOUS_DRUGS_CODES,
        payload: (drugs || []).map((item) => item.code),
      });
    }
    const type = content ? GET_DI_RESULTS_SUCCESS : GET_DI_RESULTS_ERROR;

    const payload = content ? data.viewModel : errorData;
    dispatch({ type, payload });
  } catch (err) {
    dispatch({
      type: GET_DI_RESULTS_ERROR,
      payload: genericErrorViewModel,
    });
  }
};

export const fetchDrugInteractionDetails = async (dispatch, apiPath) => {
  dispatch({ type: GET_DI_VIEWMODEL_REQUEST });
  const onError = () =>
    dispatch({
      type: GET_DI_DETAILS_VIEWMODEL_ERROR,
      payload: genericMonographErrorViewModel,
    });

  if (!apiPath) return onError();

  try {
    const { data } = await ApiService.getDrugInteractionsMonograph(apiPath);

    const type = !!data.viewModel.content
      ? GET_DI_DETAILS_VIEWMODEL_SUCCESS
      : GET_DI_DETAILS_VIEWMODEL_ERROR;

    dispatch({ type, payload: data.viewModel });
  } catch (err) {
    onError();
  }
};

export const setInteractingDrugDetails = (dispatch, metaData) => {
  dispatch({
    type: SET_INTERACTING_DETAILS,
    payload: metaData,
  });
};

export const clearDrugInteractionsDetails = (dispatch) => {
  dispatch({ type: CLEAR_INTERACTING_DETAILS });
};

export const setSelectedInteractionType = (
  dispatch,
  selectedInteractionType
) => {
  dispatch({
    type: SET_SELECTED_INTERACTION_TYPE,
    payload: selectedInteractionType,
  });
};
